import React, { useState } from "react";
import {
  Box,
  Typography,
  Paper,
  Button,
  Stack,
  // IconButton,
} from "@mui/material";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import DownloadIcon from "@mui/icons-material/Download";

const initialUploads = [
  {
    id: 1,
    name: "Insurance Document",
    type: "PDF",
    uploadedOn: "2025-05-30",
    url: null, // Placeholder for files not uploaded in session
  },
];

const UploadDocumentsPage = () => {
  const [uploadedDocs, setUploadedDocs] = useState(initialUploads);

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      const fileURL = URL.createObjectURL(file); // create blob URL
      const newDoc = {
        id: uploadedDocs.length + 1,
        name: file.name,
        type: file.type || "Unknown",
        uploadedOn: new Date().toISOString().split("T")[0],
        file, // store file object (optional, for more control)
        url: fileURL,
      };
      setUploadedDocs((prev) => [...prev, newDoc]);
    }
  };

  return (
    <Box sx={{ padding: "2rem" }}>
      <Box
        display="flex"
        flexDirection="row"
        justifyContent="space-between"
        alignItems="center"
      >
        <Box>
          <Typography variant="h6" gutterBottom>
            Uploaded Documents
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Documents you’ve submitted.
          </Typography>
        </Box>

        {/* Upload Button */}
        <Stack direction="row" spacing={2} mt={3} alignItems="center">
          <input
            accept="application/pdf,image/*"
            type="file"
            id="upload-file"
            hidden
            onChange={handleFileUpload}
          />
          <label htmlFor="upload-file">
            <Button
              variant="contained"
              component="span"
              startIcon={<UploadFileIcon />}
            >
              Upload File
            </Button>
          </label>
        </Stack>
      </Box>

      {/* Uploaded Files List */}
      <Box mt={3}>
        {uploadedDocs.length === 0 ? (
          <Typography>No uploaded documents.</Typography>
        ) : (
          uploadedDocs.map((doc) => (
            <Paper
              key={doc.id}
              sx={{
                p: 2,
                mb: 2,
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Box>
                <Typography fontWeight={600}>{doc.name}</Typography>
                <Typography>Type: {doc.type}</Typography>
                <Typography>Uploaded On: {doc.uploadedOn}</Typography>
              </Box>

              {doc.url && (
                <a
                  href={doc.url}
                  download={doc.name}
                  style={{ textDecoration: "none" }}
                >
                  <Button
                    variant="outlined"
                    startIcon={<DownloadIcon />}
                    size="small"
                  >
                    Download
                  </Button>
                </a>
              )}
            </Paper>
          ))
        )}
      </Box>
    </Box>
  );
};

export default UploadDocumentsPage;
